import React, {useEffect, useState, useRef} from 'react'
import {InputText} from 'primereact/inputtext'
import {InputNumber} from 'primereact/inputnumber'
import {Button} from 'primereact/button'
import {Checkbox} from 'primereact/checkbox'
import {Toast} from 'primereact/toast'
import {useDispatch, useSelector} from 'react-redux'
import {DialogComponent} from '../../shared/DialogComponent'
import {
  createOrUpdateEngine,
  fetchTypesList,
  getEditEngine,
  getExistItem,
  getSelectedEngine,
  getTypeList,
  setEditEngine,
  setExistItem,
  setSelectedEngine,
} from '../slice/engin.slice'
import _ from 'lodash'
import {useAppSelector} from '../../../hooks'
import {Dropdown} from 'primereact/dropdown'
import {OlangItem} from '../../shared/Olang/user-interface/OlangItem/OlangItem'
import {Message} from 'primereact/message'
import {fetchFamilles, getFamilles} from '../../Famillies/slice/famille.slice'
import {fetchValidator, getValidator} from '../../Inventory/slice/inventory.slice'
import {_fetchTagList} from '../../Capteurs/api/api'
import {Card} from 'primereact/card'
import {Divider} from 'primereact/divider'
import {FileUploadeComponent} from '../../shared/FileUploaderComponent/FileUploadeComponent'
import {Image} from 'primereact/image'
import {API_BASE_URL_IMAGE} from '../../../api/config'
import { fetchSites, getSites } from '../../Site/slice/site.slice'
import { _uploadFile, _saveFile } from '../../shared/FileUploaderComponent/api'

export const EnginEditor = (props) => {
  const toast = useRef(null)
  const [inputs, setInputs] = useState({})
  const [inputValidity, setInputValidity] = useState({})
  const [isNotValid, setIsNotValid] = useState(true)
  const [isValid, setIsValid] = useState(true)
  const [selectType, setSelectType] = useState()
  const selectedEngin = useSelector(getSelectedEngine)
  const editEngin = useSelector(getEditEngine)
  const [typeOptions, setTypeOptions] = useState([])
  const [familleOptions, setfamilleOptions] = useState([])
  const [selectFamille, setSelectFamille] = useState('')
  const familles = useAppSelector(getFamilles)
  const validators = useSelector(getValidator)
  const worksites = useSelector(getSites)
  
  // Nouveaux états pour les seuils de température et humidité
  const [temperatureThresholdMin, setTemperatureThresholdMin] = useState(null)
  const [temperatureThresholdMax, setTemperatureThresholdMax] = useState(null)
  const [humidityThresholdMin, setHumidityThresholdMin] = useState(null)
  const [humidityThresholdMax, setHumidityThresholdMax] = useState(null)
  
  // États pour les checkboxes d'alerte de seuil (0 ou 1)
  const [temperatureThresholdMinAlert, setTemperatureThresholdMinAlert] = useState(0)
  const [temperatureThresholdMaxAlert, setTemperatureThresholdMaxAlert] = useState(0)
  const [humidityThresholdMinAlert, setHumidityThresholdMinAlert] = useState(0)
  const [humidityThresholdMaxAlert, setHumidityThresholdMaxAlert] = useState(0)
  
  // États pour les tags
  const [availableTags, setAvailableTags] = useState([])
  const [selectedTag, setSelectedTag] = useState(null)
  const [loadingTags, setLoadingTags] = useState(false)
  const [useManualMac, setUseManualMac] = useState(false)
  const [manualMacAddress, setManualMacAddress] = useState('')
  
  // Variables manquantes pour la compatibilité
  const [imageId, setImageId] = useState()
  const [imageChange, setImageChange] = useState(false)
  const [pendingImageFile, setPendingImageFile] = useState(null)
  const [previewImageUrl, setPreviewImageUrl] = useState(null)
  
  // États pour l'alerte de période d'inactivité
  const [inactivityPeriodValue, setInactivityPeriodValue] = useState(null)
  const [inactivityPeriodUnit, setInactivityPeriodUnit] = useState('d') // 'h', 'd', 'w', 'm', 'y'
  const [inactivityAlertEnabled, setInactivityAlertEnabled] = useState(false)

  const dispatch = useDispatch()
  let types = useAppSelector(getTypeList)
  let alreadyExist = useAppSelector(getExistItem)
  
  // Fonction pour charger les tags depuis l'API
  const loadTags = async () => {
    setLoadingTags(true)
    try {
      console.log('🏷️ Chargement des tags pour le dropdown...')
      const response = await _fetchTagList()
      console.log('🏷️ Réponse API tags:', response)
      
      if (response.data && response.data.success && Array.isArray(response.data.result)) {
        const tagsForDropdown = response.data.result.map(tag => ({
          label: `${tag.tagname || tag.labeltag || tag.macAddr || tag.name || tag.label || tag.id} - ${tag.type || 'Capteur'}`,
          value: tag.id || tag.tagId,
          tagname: tag.tagname || tag.labeltag || tag.macAddr || tag.name || tag.label || tag.id,
          tag: tag
        }))
        setAvailableTags(tagsForDropdown)
        console.log('🏷️ Tags chargés:', tagsForDropdown.length)
      } else {
        console.warn('🚫 Réponse tags invalide:', response)
        setAvailableTags([])
      }
    } catch (error) {
      console.error('🚫 Erreur lors du chargement des tags:', error)
      setAvailableTags([])
    } finally {
      setLoadingTags(false)
    }
  }

  const onHide = () => {
    typeof props.onHide == 'function' && props.onHide()
    dispatch(setSelectedEngine(null))
    dispatch(setEditEngine(false))
    setSelectType(null)
    setSelectFamille(null)
    setIsNotValid(true)
    setInputValidity({})
    setUseManualMac(false)
    setManualMacAddress('')
    setSelectedTag(null)
    // Reset des états d'alerte
    setTemperatureThresholdMinAlert(0)
    setTemperatureThresholdMaxAlert(0)
    setHumidityThresholdMinAlert(0)
    setHumidityThresholdMaxAlert(0)
    // Reset des seuils
    setTemperatureThresholdMin(null)
    setTemperatureThresholdMax(null)
    setHumidityThresholdMin(null)
    setHumidityThresholdMax(null)
    // Reset de l'alerte d'inactivité
    setInactivityPeriodValue(null)
    setInactivityPeriodUnit('day')
    setInactivityAlertEnabled(false)
    // Reset de l'image en attente
    setPendingImageFile(null)
    setPreviewImageUrl(null)
  }

  const validateFields = (validators, old) => {
    let isValid = true
    validators.forEach((validator) => {
      let _regExp = new RegExp(validator.regExp.slice(1, -1))
      
      // Special case for reference field - allow up to 50 characters
      if (validator.id === 'reference') {
        _regExp = /^.{0,50}$/
      }
      
      // Skip validation for famille field (not required)
      if (validator.id === 'famille') {
        return
      }
      
      if (validator.isRequired && _regExp.test(old[validator.id]) === false) {
        isValid = false
      }
    })

    return isValid
  }

  const onInputChange = (e) => {
    console.log('onInputChange e:', e)
    let old = _.cloneDeep(selectedEngin)
    
    // Gérer les cas où e.target peut être undefined (ex: checkboxes avec objet personnalisé)
    const fieldName = e.key || (e.target ? e.target.name : null)
    const fieldValue = e.value !== undefined ? e.value : (e.target ? e.target.value : null)
    
    old = {
      ...old,
      imageid: imageId,
      typeID: selectType?.code,
      [fieldName]: fieldValue,
    }
    console.log('old:', old)
    dispatch(setSelectedEngine(old))
    
    // Validate individual field and update inputValidity
    const fieldValidator = validators?.find((v) => v.id === fieldName)
    let fieldValidity = true
    
    if (fieldValidator) {
      // Skip validation for famille field (not required)
      if (fieldValidator.id === 'famille') {
        fieldValidity = true
      } else {
        let _regExp = new RegExp(fieldValidator.regExp.slice(1, -1))
        
        // Special case for reference field - allow up to 50 characters
        if (fieldValidator.id === 'reference') {
          _regExp = /^.{0,50}$/
        }
        
        if (fieldValidator.isRequired && !_regExp.test(old[fieldName])) {
          fieldValidity = false
        }
      }
    }
    
    setInputValidity(prev => ({
      ...prev,
      [fieldName]: fieldValidity
    }))
    
    let isValid = validateFields(validators, old)
    const areAllRequiredFieldsFilled = validators
      .filter((validator) => validator.isRequired && validator.id !== 'famille')
      .every((validator) => !!old[validator.id])
    setIsNotValid(!areAllRequiredFieldsFilled || !isValid)
  }

  useEffect(() => {
    dispatch(fetchTypesList())
  }, [])

  useEffect(() => {
    console.log('📷 selectedEngin changé:', {
      id: selectedEngin?.id,
      imageid: selectedEngin?.imageid,
      image: selectedEngin?.image,
      imageChange
    })
    if (!selectedEngin?.id) {
      setImageChange(true)
    } else if (selectedEngin?.id) {
      setImageChange(false)
    }
  }, [selectedEngin])

  // Valider les champs quand on charge un engin existant
  useEffect(() => {
    if (selectedEngin && validators && validators.length > 0) {
      console.log('🔍 Validation des champs au chargement:', selectedEngin)
      const isValid = validateFields(validators, selectedEngin)
      const areAllRequiredFieldsFilled = validators
        .filter((validator) => validator.isRequired && validator.id !== 'famille')
        .every((validator) => !!selectedEngin[validator.id])
      
      console.log('🔍 isValid:', isValid)
      console.log('🔍 areAllRequiredFieldsFilled:', areAllRequiredFieldsFilled)
      setIsNotValid(!areAllRequiredFieldsFilled || !isValid)
    }
  }, [selectedEngin, validators])

  const onSave = async (e) => {
    console.log('🔍 onSave appelé')
    console.log('🔍 isNotValid:', isNotValid)
    console.log('🔍 selectedEngin:', selectedEngin)
    console.log('🔍 validators:', validators)
    
    if (isNotValid) {
      console.log('❌ Validation échouée - champs requis manquants')
      const requiredFieldsValidity = {}
      validators
        .filter((validator) => validator.isRequired)
        .forEach((validator) => {
          requiredFieldsValidity[validator.id] = !!selectedEngin?.[validator.id]
        })
      console.log('🔍 requiredFieldsValidity:', requiredFieldsValidity)
      setInputValidity(requiredFieldsValidity)
      
      toast.current?.show({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Veuillez remplir tous les champs obligatoires',
        life: 3000
      })
      return
    }
    // Trouver le tag sélectionné pour récupérer son nom
    const selectedTagObject = availableTags.find(tag => tag.value === selectedTag)
    // const tagName = selectedTagObject ? selectedTagObject.tag.name || selectedTagObject.tag.label || selectedTagObject.tag.id : null
    
    console.log('🔍 États d\'alerte actuels:', {
      temperatureThresholdMinAlert,
      temperatureThresholdMaxAlert,
      humidityThresholdMinAlert,
      humidityThresholdMaxAlert
    })
    
    // Si une image est en attente, l'uploader d'abord
    let uploadedImageId = imageId
    if (pendingImageFile) {
      console.log('📷 Upload de l\'image en attente...')
      try {
        const formData = new FormData()
        formData.append('File', pendingImageFile) // Clé 'File' avec majuscule
        
        let x = Math.floor(Math.random() * 10000000 + 1)
        const srcID = selectedEngin?.id || selectedEngin?.uid || 0
        const desc = 'profile'
        const src = 'engin'
        
        // Uploader le fichier
        const uploadResult = await _uploadFile(formData, {
          name: srcID + desc + src + '_' + x
        })
        
        console.log('📷 Résultat upload:', uploadResult)
        
        if (uploadResult.success && uploadResult.result) {
          // Sauvegarder les métadonnées du fichier
          const saveResult = await _saveFile({
            src: src,
            srcID: srcID,
            id: selectedEngin?.imageid || 0,
            desc: desc,
            path: uploadResult.result.result // Le chemin est dans uploadResult.result.result
          })
          
          console.log('📷 Résultat save:', saveResult)
          
          // La structure peut être saveResult.data.result OU saveResult.result
          const resultArray = saveResult.data?.result || saveResult.result
          
          if (resultArray && Array.isArray(resultArray) && resultArray[0]) {
            uploadedImageId = resultArray[0].id
            console.log('📷 Image uploadée et sauvegardée avec succès, ID:', uploadedImageId)
          } else {
            throw new Error('Save failed: ' + JSON.stringify(saveResult))
          }
        } else {
          throw new Error('Upload failed: ' + JSON.stringify(uploadResult))
        }
      } catch (error) {
        console.error('❌ Erreur lors de l\'upload de l\'image:', error)
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors de l\'upload de l\'image: ' + error.message,
          life: 3000
        })
        return
      }
    }
    
    // Construire la valeur Alert_Period si l'alerte d'inactivité est activée
    const alertPeriod = inactivityAlertEnabled && inactivityPeriodValue 
      ? `${inactivityPeriodValue}${inactivityPeriodUnit}` 
      : null
    
    // Préparer les données avec les nouveaux champs
    const engineData = {
      ...selectedEngin,
      imageId: uploadedImageId, 
      // familleId: selectFamille?.code,
      // Champs de seuils
      temperatureThresholdMin,
      temperatureThresholdMax,
      humidityThresholdMin,
      humidityThresholdMax,
      // Champs d'alerte (0 ou 1) - TOUJOURS envoyés avec valeurs explicites
      temperatureThresholdMinAlert: temperatureThresholdMinAlert || 0,
      temperatureThresholdMaxAlert: temperatureThresholdMaxAlert || 0,
      humidityThresholdMinAlert: humidityThresholdMinAlert || 0,
      humidityThresholdMaxAlert: humidityThresholdMaxAlert || 0,
      // Alerte de période d'inactivité
      maxInactiveBeforeAlert: alertPeriod
    }

    
    
    
    console.log('💾 Sauvegarde engin avec nouveaux champs:', engineData)
    console.log('🚨 Champs d\'alerte dans le payload:', {
      temperatureThresholdMinAlert: engineData.temperatureThresholdMinAlert,
      temperatureThresholdMaxAlert: engineData.temperatureThresholdMaxAlert,
      humidityThresholdMinAlert: engineData.humidityThresholdMinAlert,
      humidityThresholdMaxAlert: engineData.humidityThresholdMaxAlert
    })
    console.log('engineData:', engineData)
    // return
    try {
      const result = await dispatch(createOrUpdateEngine(engineData))
      console.log('🔍 Résultat sauvegarde engin:', result)
      
      if (result.payload && result.payload.success !== false) {
        // Déterminer si c'est une création ou modification
        const isEdit = selectedEngin?.id
        
        toast.current?.show({
          severity: 'success',
          summary: 'Succès',
          detail: isEdit ? 'Capteur modifié avec succès' : 'Capteur créé avec succès',
          life: 3000
        })
        
        // Nettoyer l'image en attente
        setPendingImageFile(null)
        setPreviewImageUrl(null)
        
        // Fermer le dialog après un délai
        setTimeout(() => {
          onHide()
        }, 1500)
      } else {
        console.error('❌ Erreur lors de la sauvegarde:', result.payload)
        toast.current?.show({
          severity: 'error',
          summary: 'Erreur',
          detail: result.payload?.message || 'Erreur lors de la sauvegarde du capteur',
          life: 3000
        })
      }
    } catch (error) {
      console.error('❌ Erreur lors de la sauvegarde:', error)
      toast.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur de connexion lors de la sauvegarde',
        life: 3000
      })
    }
  }

  // Nouvelle fonction pour gérer la sélection de fichier (sans upload immédiat)
  const onImageSelect = (e) => {
    console.log('📷 Fichier sélectionné:', e)
    
    // Récupérer le fichier depuis l'événement
    const file = e.files && e.files[0]
    
    if (file) {
      console.log('📷 Fichier valide:', file.name, file.type)
      
      // Stocker le fichier pour l'upload ultérieur
      setPendingImageFile(file)
      
      // Créer une URL de prévisualisation
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreviewImageUrl(reader.result)
        setImageChange(false) // Passer en mode affichage
      }
      reader.readAsDataURL(file)
      
      toast.current?.show({
        severity: 'info',
        summary: 'Image sélectionnée',
        detail: 'L\'image sera uploadée lors de la sauvegarde',
        life: 3000
      })
    } else {
      console.error('📷 Aucun fichier sélectionné')
    }
  }

  useEffect(() => {
    let dt = types
    if(!Array.isArray(dt)) dt = []
    setTypeOptions([
      {name: 'selectionner', code: 0},
      ...dt.map((typ) => ({
        name: typ.label,
        code: typ.typeID,
      })),
    ])
  }, [types])

  const footer = (
    <div className='flex gap-3 justify-content-end'>
      <Button
        onClick={onHide}
        className=' p-button-danger'
        label={<OlangItem olang='Annuler' />}
        icon='pi pi-times'
      />
      <Button onClick={onSave} label={<OlangItem olang='Sauvegarder' />} icon='pi pi-check' />
    </div>
  )

  const header = (
    <div>
      {selectedEngin?.id ? <OlangItem olang='Edit.Engin' /> : <OlangItem olang='Create.Engin' />}
    </div>
  )

  useEffect(() => {
    if (alreadyExist) {
      setTimeout(() => {
        dispatch(setExistItem(false))
      }, 3000)
    }
  }, [alreadyExist])

  useEffect(() => {
    console.log('🔄 EnginEditor monté, fetch familles et tags')
    dispatch(fetchFamilles({ src: 'enginType' }))
    loadTags() // Charger les tags au montage
  }, [])
  
  // useEffect pour initialiser les valeurs des seuils depuis selectedEngin
  useEffect(() => {
    if (selectedEngin) {
      setTemperatureThresholdMin(selectedEngin.temperatureThresholdMin || null)
      setTemperatureThresholdMax(selectedEngin.temperatureThresholdMax || null)
      setHumidityThresholdMin(selectedEngin.humidityThresholdMin || null)
      setHumidityThresholdMax(selectedEngin.humidityThresholdMax || null)
      
      // Initialiser les états d'alerte depuis selectedEngin (convertir en 0 ou 1)
      setTemperatureThresholdMinAlert(selectedEngin.temperatureThresholdMinAlert ? 1 : 0)
      setTemperatureThresholdMaxAlert(selectedEngin.temperatureThresholdMaxAlert ? 1 : 0)
      setHumidityThresholdMinAlert(selectedEngin.humidityThresholdMinAlert ? 1 : 0)
      setHumidityThresholdMaxAlert(selectedEngin.humidityThresholdMaxAlert ? 1 : 0)
      
      // Initialiser l'alerte de période d'inactivité depuis selectedEngin
      if (selectedEngin.maxInactiveBeforeAlert) {
        // Parser la valeur (ex: "3d", "2m", "1w")
        const match = selectedEngin.maxInactiveBeforeAlert.match(/^(\d+)(hour|day|week|month|year)$/)
        if (match) {
          setInactivityPeriodValue(parseInt(match[1]))
          setInactivityPeriodUnit(match[2])
          setInactivityAlertEnabled(true)
        }
      } else {
        setInactivityPeriodValue(null)
        setInactivityPeriodUnit('day')
        setInactivityAlertEnabled(false)
      }
      
      // Pour le tag, chercher dans availableTags par nom (tagName) ou utiliser tagname directement
      if (selectedEngin.tagname) {
        // Si tagname existe, vérifier s'il est dans la liste des tags
        const matchingTag = availableTags.find(tag => 
          tag.tag.name === selectedEngin.tagname || 
          tag.tag.label === selectedEngin.tagname ||
          tag.tag.id === selectedEngin.tagname
        )
        
        if (matchingTag) {
          // Tag trouvé dans la liste
          setSelectedTag(matchingTag.value)
          setUseManualMac(false)
          setManualMacAddress('')
        } else {
          // Tag non trouvé, utiliser la saisie manuelle
          setManualMacAddress(selectedEngin.tagname)
          setUseManualMac(true)
          setSelectedTag(null)
        }
      } else {
        setSelectedTag(null)
        setManualMacAddress('')
        setUseManualMac(false)
      }
    } else {
      // Réinitialiser pour un nouvel engin
      setTemperatureThresholdMin(null)
      setTemperatureThresholdMax(null)
      setHumidityThresholdMin(null)
      setHumidityThresholdMax(null)
      setTemperatureThresholdMinAlert(0)
      setTemperatureThresholdMaxAlert(0)
      setHumidityThresholdMinAlert(0)
      setHumidityThresholdMaxAlert(0)
      setSelectedTag(null)
      setInactivityPeriodValue(null)
      setInactivityPeriodUnit('day')
      setInactivityAlertEnabled(false)
    }
  }, [selectedEngin, availableTags])

  useEffect(() => {
    let fml = familles;
    if(!Array.isArray(fml)) fml = []
    setfamilleOptions([
      ...fml.map((typ) => ({
        name: typ.label,
        code: typ.id,
      })),
    ])
  }, [familles])

  // useEffect pour initialiser selectFamille quand selectedEngin ou familleOptions changent
  useEffect(() => {
    if (selectedEngin?.familleId && familleOptions.length > 0) {
      const selectedFamille = familleOptions.find(f => f.code === selectedEngin.familleId)
      if (selectedFamille) {
        setSelectFamille(selectedFamille)
      }
    }
  }, [selectedEngin, familleOptions])

  useEffect(()=>{
    console.log('maxInactiveBeforeAlert:', selectedEngin, selectedEngin?.maxInactiveBeforeAlert)
    // if(selectedEngin?.maxInactiveBeforeAlert){
    //    let split = (selectedEngin?.maxInactiveBeforeAlert || '').split('')
    //    setInactivityPeriodUnit(split?.[1] || 'd')
    //    setInactivityPeriodValue(parseInt(split?.[0] || 0))
    //    setInactivityAlertEnabled(true)
    // }
  },[selectedEngin])

  useEffect(() => {
    dispatch(fetchSites())
  }, [])

  useEffect(()=>{
    console.log('selectedEngin:', selectedEngin)
  },[selectedEngin])

  const _referenceValidator = validators?.find((field) => field.id === 'reference')
  const _brandValidator = validators?.find((field) => field.id === 'brand')
  const _infosAdditionnellesValidator = validators?.find(
    (field) => field.id === 'infosAdditionnelles'
  )
  const _familleValidator = validators?.find((field) => field.id === 'famille')

  return (
    <div>
      <DialogComponent
        visible={editEngin}
        header={header}
        onHide={onHide}
        className='w-11 md:w-6'
        footer={footer}
      >
        <div className='p-4'>
          {/* Message d'erreur */}
          {alreadyExist && (
            <div className='mb-4'>
              <Message
                severity='error'
                text={<OlangItem olang='the.engine.is.already.existed' />}
                className='w-full'
              />
            </div>
          )}

          {/* Image du capteur - EN HAUT */}
          <Card title="Photo du Capteur" className='mb-4'>
            <div className='flex flex-column align-items-center gap-3'>
              {imageChange ? (
                <div className='w-full flex flex-column align-items-center gap-3'>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        onImageSelect({ files: [e.target.files[0]] })
                      }
                    }}
                    style={{ display: 'none' }}
                    id="image-upload-input"
                  />
                  <label htmlFor="image-upload-input">
                    <Button
                      label="Sélectionner une image"
                      icon="pi pi-upload"
                      className="p-button-outlined"
                      onClick={() => document.getElementById('image-upload-input').click()}
                      type="button"
                    />
                  </label>
                  <Button
                    label="Annuler"
                    icon="pi pi-times"
                    className="p-button-text p-button-sm"
                    onClick={() => {
                      setImageChange(false)
                      setPendingImageFile(null)
                      setPreviewImageUrl(null)
                    }}
                  />
                </div>
              ) : (
                <div className='flex flex-column align-items-center gap-2'>
                  {(previewImageUrl || selectedEngin?.image) ? (
                    <>
                      <Image
                        src={previewImageUrl || `${API_BASE_URL_IMAGE}${selectedEngin.image}`}
                        alt='Image du capteur'
                        width='120'
                        height='120'
                        preview
                        imageStyle={{objectFit: 'cover', borderRadius: '10px'}}
                        onError={(e) => {
                          console.error('📷 Erreur chargement image:', previewImageUrl || `${API_BASE_URL_IMAGE}${selectedEngin.image}`)
                        }}
                      />
                      {pendingImageFile && (
                        <div className='text-center'>
                          <i className='pi pi-info-circle text-blue-500 mr-2'></i>
                          <span className='text-sm text-600'>Image en attente d'upload</span>
                        </div>
                      )}
                      <Button
                        label="Changer l'image"
                        icon="pi pi-camera"
                        className="p-button-outlined p-button-sm"
                        onClick={() => setImageChange(true)}
                      />
                    </>
                  ) : (
                    <>
                      <div style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '10px',
                        backgroundColor: '#f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="pi pi-image" style={{ fontSize: '48px', color: '#999' }}></i>
                      </div>
                      <Button
                        label="Ajouter une image"
                        icon="pi pi-camera"
                        className="p-button-outlined p-button-sm"
                        onClick={() => setImageChange(true)}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
          </Card>

          {/* Informations générales */}
          <Card title="Informations Générales" className='mb-4'>
            <div className='grid'>
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='reference' className='font-semibold'>
                    <OlangItem olang='Reference' />
                    {_referenceValidator?.isRequired == 1 && <span className='text-red-500 ml-1'>*</span>}
                  </label>
                  <InputText
                    name='reference'
                    id='reference'
                    value={selectedEngin?.reference || ''}
                    onChange={onInputChange}
                    className={`w-full ${alreadyExist ? 'p-invalid' : ''} ${
                      inputValidity['reference'] === false ? 'p-invalid' : ''
                    }`}
                    placeholder="Référence de l'engin"
                  />
                  {inputValidity['reference'] === false && (
                    <small className='p-error'>{_referenceValidator?.messageError}</small>
                  )}
                </div>
              </div>
              
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='brand' className='font-semibold'>
                    <OlangItem olang='Brand' />
                    {_brandValidator?.isRequired == 1 && <span className='text-red-500 ml-1'>*</span>}
                  </label>
                  <InputText
                    name='brand'
                    id='brand'
                    value={selectedEngin?.brand || ''}
                    onChange={onInputChange}
                    className={`w-full ${alreadyExist ? 'p-invalid' : ''} ${
                      inputValidity['brand'] === false ? 'p-invalid' : ''
                    }`}
                    placeholder="Marque"
                  />
                  {inputValidity['brand'] === false && (
                    <small className='p-error'>{_brandValidator?.messageError}</small>
                  )}
                </div>
              </div>
              
              
              
              
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='famille' className='font-semibold'>
                    <OlangItem olang='famille.list' />
                  </label>
                  <Dropdown
                    id='familleId'
                    name='familleId'
                    options={familleOptions}
                    onChange={(e) => {
                      // setSelectFamille(e.value)
                      onInputChange(e)
                    }}
                    placeholder="Sélectionner une famille"
                    value={selectedEngin?.familleId}
                    className={`w-full ${alreadyExist ? 'p-invalid' : ''} ${
                      inputValidity['famille'] === false ? 'p-invalid' : ''
                    }`}
                    optionLabel='name'
                    optionValue='code'
                  />
                  {inputValidity['famille'] === false && (
                    <small className='p-error'>{_familleValidator?.messageError}</small>
                  )}
                </div>
              </div>
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='famille' className='font-semibold'>
                    <OlangItem olang='area.label' />
                  </label>
                  <Dropdown
                    id='area'
                    name='area'
                    options={worksites.map(o => ({label:o.label, value: (o.id+'#'+o.type).toLowerCase()}))}
                    onChange={(e) => {
                      onInputChange(e)
                    }}
                    placeholder="Sélectionner une zone"
                    value={
                      selectedEngin?.['area'] || 
                      (selectedEngin?.['LocationID'] ? (selectedEngin?.['LocationID'] + '#' + selectedEngin?.['LocationObject']).toLowerCase() 
                      : null)}
                    className={`w-full ${alreadyExist ? 'p-invalid' : ''} ${
                      inputValidity['area'] === false ? 'p-invalid' : ''
                    }`}
                    optionLabel='label'
                    disabled={selectedEngin?.uid != null}
                  />
                  {inputValidity['area'] === false && (
                    <small className='p-error'>{_familleValidator?.messageError}</small>
                  )}
                </div>
              </div>
              <div className='col-12'>
                <div className='field'>
                  <label htmlFor='infosAdditionnelles' className='font-semibold'>
                    <OlangItem olang='Informations.additionnelles' />
                    {_infosAdditionnellesValidator?.isRequired == 1 && <span className='text-red-500 ml-1'>*</span>}
                  </label>
                  <InputText
                    id='infosAdditionnelles'
                    value={selectedEngin?.infosAdditionnelles || ''}
                    onChange={onInputChange}
                    name='infosAdditionnelles'
                    className={`w-full ${alreadyExist ? 'p-invalid' : ''} ${
                      inputValidity['infosAdditionnelles'] === false ? 'p-invalid' : ''
                    }`}
                    placeholder="Informations complémentaires"
                  />
                  {inputValidity['infosAdditionnelles'] === false && (
                    <small className='p-error'>{_infosAdditionnellesValidator?.messageError}</small>
                  )}
                </div>
              </div>
            </div>
          </Card>

          {/* Seuils de température et humidité */}
          <Card title="Seuils de Surveillance" className='mb-4'>
            <div className='grid'>
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='temperatureThresholdMin' className='font-semibold text-orange-600'>
                    <i className='pi pi-thermometer mr-2'></i>
                    Température Minimale (°C)
                  </label>
                  <InputNumber
                    id='temperatureThresholdMin'
                    name='temperatureThresholdMin'
                    value={temperatureThresholdMin}
                    onValueChange={(e) => onInputChange({value: e.value, key: 'temperatureThresholdMin'})}
                    className='w-full'
                    placeholder="Ex: -10"
                    suffix=' °C'
                    showButtons
                    min={-50}
                    max={100}
                  />
                  <div className='field-checkbox mt-2'>
                    <Checkbox
                      inputId='temperatureThresholdMinAlert'
                      name='temperatureThresholdMinAlert'
                      checked={temperatureThresholdMinAlert === 1}
                      onChange={(e) => {
                        const value = e.checked ? 1 : 0;
                        setTemperatureThresholdMinAlert(value);
                        onInputChange({value: value, key: 'temperatureThresholdMinAlert'});
                      }}
                    />
                    <label htmlFor='temperatureThresholdMinAlert' className='ml-2 text-sm text-orange-600'>
                      <i className='pi pi-bell mr-1'></i>
                      Alerte seuil minimum
                    </label>
                  </div>
                </div>
              </div>
              
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='temperatureThresholdMax' className='font-semibold text-red-600'>
                    <i className='pi pi-thermometer mr-2'></i>
                    Température Maximale (°C)
                  </label>
                  <InputNumber
                    id='temperatureThresholdMax'
                    name='temperatureThresholdMax'
                    value={temperatureThresholdMax}
                    onValueChange={(e) => onInputChange({value: e.value, key: 'temperatureThresholdMax'})}
                    className='w-full'
                    placeholder="Ex: 50"
                    suffix=' °C'
                    showButtons
                    min={-50}
                    max={100}
                  />
                  <div className='field-checkbox mt-2'>
                    <Checkbox
                      inputId='temperatureThresholdMaxAlert'
                      name='temperatureThresholdMaxAlert'
                      checked={temperatureThresholdMaxAlert === 1}
                      onChange={(e) => {
                        const value = e.checked ? 1 : 0;
                        setTemperatureThresholdMaxAlert(value);
                        onInputChange({value: value, key: 'temperatureThresholdMaxAlert'});
                      }}
                    />
                    <label htmlFor='temperatureThresholdMaxAlert' className='ml-2 text-sm text-red-600'>
                      <i className='pi pi-bell mr-1'></i>
                      Alerte seuil maximum
                    </label>
                  </div>
                </div>
              </div>
              
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='humidityThresholdMin' className='font-semibold text-blue-600'>
                    <i className='fa-duotone fa-regular fa-droplet-degree mr-2'></i>
                    Humidité Minimale (%)
                  </label>
                  <InputNumber
                    id='humidityThresholdMin'
                    name='humidityThresholdMin'
                    value={humidityThresholdMin}
                    onValueChange={(e) => onInputChange({value: e.value, key: 'humidityThresholdMin'})}
                    className='w-full'
                    placeholder="Ex: 20"
                    suffix=' %'
                    showButtons
                    min={0}
                    max={100}
                  />
                  <div className='field-checkbox mt-2'>
                    <Checkbox
                      inputId='humidityThresholdMinAlert'
                      name='humidityThresholdMinAlert'
                      checked={humidityThresholdMinAlert === 1}
                      onChange={(e) => {
                        const value = e.checked ? 1 : 0;
                        setHumidityThresholdMinAlert(value);
                        onInputChange({value: value, key: 'humidityThresholdMinAlert'});
                      }}
                    />
                    <label htmlFor='humidityThresholdMinAlert' className='ml-2 text-sm text-blue-600'>
                      <i className='pi pi-bell mr-1'></i>
                      Alerte seuil minimum
                    </label>
                  </div>
                </div>
              </div>
              
              <div className='col-12 md:col-6'>
                <div className='field'>
                  <label htmlFor='humidityThresholdMax' className='font-semibold text-cyan-600'>
                    <i className='fa-duotone fa-regular fa-droplet-degree mr-2'></i>
                    Humidité Maximale (%)
                  </label>
                  <InputNumber
                    id='humidityThresholdMax'
                    name='humidityThresholdMax'
                    value={humidityThresholdMax}
                    onValueChange={(e) => onInputChange({value: e.value, key: 'humidityThresholdMax'})}
                    className='w-full'
                    placeholder="Ex: 80"
                    suffix=' %'
                    showButtons
                    min={0}
                    max={100}
                  />
                  <div className='field-checkbox mt-2'>
                    <Checkbox
                      inputId='humidityThresholdMaxAlert'
                      name='humidityThresholdMaxAlert'
                      checked={humidityThresholdMaxAlert === 1}
                      onChange={(e) => {
                        const value = e.checked ? 1 : 0;
                        setHumidityThresholdMaxAlert(value);
                        onInputChange({value: value, key: 'humidityThresholdMaxAlert'});
                      }}
                    />
                    <label htmlFor='humidityThresholdMaxAlert' className='ml-2 text-sm text-cyan-600'>
                      <i className='pi pi-bell mr-1'></i>
                      Alerte seuil maximum
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Résumé des alertes sélectionnées */}
          <Card title="Résumé des Alertes de Seuil" className='mb-4'>
            {(temperatureThresholdMinAlert === 1 || temperatureThresholdMaxAlert === 1 || humidityThresholdMinAlert === 1 || humidityThresholdMaxAlert === 1) ? (
              <div>
                <p className='text-green-600 font-semibold mb-3'>
                  <i className='pi pi-check-circle mr-2'></i>
                  Les alertes suivantes seront configurées automatiquement :
                </p>
                <div className='grid'>
                  {temperatureThresholdMinAlert === 1 && (
                    <div className='col-12 md:col-6 mb-2'>
                      <div className='p-2 border-round bg-orange-50 border-1 border-orange-200'>
                        <i className='pi pi-thermometer text-orange-600 mr-2'></i>
                        <span className='text-orange-800'>Température minimale ({temperatureThresholdMin}°C)</span>
                      </div>
                    </div>
                  )}
                  {temperatureThresholdMaxAlert === 1 && (
                    <div className='col-12 md:col-6 mb-2'>
                      <div className='p-2 border-round bg-red-50 border-1 border-red-200'>
                        <i className='pi pi-thermometer text-red-600 mr-2'></i>
                        <span className='text-red-800'>Température maximale ({temperatureThresholdMax}°C)</span>
                      </div>
                    </div>
                  )}
                  {humidityThresholdMinAlert === 1 && (
                    <div className='col-12 md:col-6 mb-2'>
                      <div className='p-2 border-round bg-blue-50 border-1 border-blue-200'>
                        <i className='fa-duotone fa-regular fa-droplet-degree text-blue-600 mr-2'></i>
                        <span className='text-blue-800'>Humidité minimale ({humidityThresholdMin}%)</span>
                      </div>
                    </div>
                  )}
                  {humidityThresholdMaxAlert === 1 && (
                    <div className='col-12 md:col-6 mb-2'>
                      <div className='p-2 border-round bg-cyan-50 border-1 border-cyan-200'>
                        <i className='fa-duotone fa-regular fa-droplet-degree text-cyan-600 mr-2'></i>
                        <span className='text-cyan-800'>Humidité maximale ({humidityThresholdMax}%)</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className='text-center py-4'>
                <i className='pi pi-info-circle text-blue-500 text-3xl mb-2 block'></i>
                <p className='text-600 m-0'>
                  Aucune alerte de seuil sélectionnée. Cochez les cases sous les seuils pour que le backend configure des alertes automatiques.
                </p>
              </div>
            )}
          </Card>

          {/* Tag associé */}
          <Card title="Tag Associé" className='mb-4'>
            <div className='field mb-3'>
              <div className='flex align-items-center justify-content-between mb-2'>
                <label htmlFor='selectedTag' className='font-semibold text-green-600'>
                  <i className='pi pi-tag mr-2'></i>
                  {useManualMac ? 'Adresse MAC Manuelle' : 'Sélectionner un Tag'}
                </label>
                <Button
                  type='button'
                  label={useManualMac ? 'Utiliser la liste' : 'Saisie manuelle'}
                  icon={useManualMac ? 'pi pi-list' : 'pi pi-pencil'}
                  className='p-button-sm p-button-outlined hidden'
                  disabled={!!selectedEngin?.id}
                  onClick={() => {
                    setUseManualMac(!useManualMac)
                    if (!useManualMac) {
                      setSelectedTag(null)
                    } else {
                      setManualMacAddress('')
                    }
                  }}
                />
              </div>
              
              {/* {useManualMac ? (
                <div>
                  <InputText
                    id='manualMac'
                    value={manualMacAddress}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase()
                      setManualMacAddress(value)
                      onInputChange({
                        key: 'tagname',
                        value: value
                      })
                    }}
                    placeholder='Ex: BC5729028645'
                    className='w-full'
                    maxLength={12}
                    disabled={!!selectedEngin?.id}
                  />
                  <small className='text-500 block mt-2'>
                    Entrez l'adresse MAC du tag (12 caractères hexadécimaux)
                  </small>
                  {manualMacAddress && manualMacAddress.length !== 12 && (
                    <small className='text-red-500 block mt-1'>
                      L'adresse MAC doit contenir exactement 12 caractères
                    </small>
                  )}
                </div>
              ) : (
                
              )} */}
              <div>
                  <Dropdown
                    id='selectedTag'
                    name='tagId'
                    editable
                    value={selectedEngin?.tagname || selectedEngin?.tagId}
                    options={availableTags}
                    onChange={(e) => {
                      // Trouver le tag sélectionné pour récupérer son tagname
                      const selectedTagObj = availableTags.find(tag => tag.value === e.value)
                      onInputChange({
                        ...e,
                        key: 'tagname',
                        value: selectedTagObj?.tagname || e.value
                      })
                    }}
                    placeholder={loadingTags ? "Chargement des tags..." : "Sélectionner un tag"}
                    className='w-full'
                    optionLabel='label'
                    optionValue='tagname'
                    disabled={loadingTags || !!selectedEngin?.id}
                    filter
                    filterBy='label'
                    emptyMessage="Aucun tag disponible"
                    emptyFilterMessage="Aucun tag trouvé"
                  />
                  <small className='text-500 block mt-2'>
                    Sélectionnez le tag capteur à associer à cet engin pour la surveillance
                  </small>
                </div>
            </div>
          </Card>

          {/* Alerte de Période d'Inactivité */}
          <Card title="Alerte de Période d'Inactivité" className='mb-4'>
            <div className='field'>
              <div className='field-checkbox mb-3'>
                <Checkbox
                  inputId='inactivityAlertEnabled'
                  checked={inactivityAlertEnabled}
                  onChange={(e) => setInactivityAlertEnabled(e.checked)}
                />
                <label htmlFor='inactivityAlertEnabled' className='ml-2 font-semibold text-purple-600'>
                  <i className='pi pi-clock mr-2'></i>
                  Activer l'alerte d'inactivité du capteur
                </label>
              </div>
              
              {inactivityAlertEnabled && (
                <div className='grid'>
                  <div className='col-12 md:col-6'>
                    <label htmlFor='inactivityPeriodValue' className='font-semibold block mb-2'>
                      Durée
                    </label>
                    <InputNumber
                      id='inactivityPeriodValue'
                      value={inactivityPeriodValue}
                      onValueChange={(e) => setInactivityPeriodValue(e.value)}
                      className='w-full'
                      placeholder="Ex: 3"
                      showButtons
                      min={1}
                      max={999}
                    />
                  </div>
                  
                  <div className='col-12 md:col-6'>
                    <label htmlFor='inactivityPeriodUnit' className='font-semibold block mb-2'>
                      Unité de temps
                    </label>
                    <Dropdown
                      id='inactivityPeriodUnit'
                      value={inactivityPeriodUnit}
                      options={[
                        { label: 'Heure(s)', value: 'hour' },
                        { label: 'Jour(s)', value: 'day' },
                        { label: 'Semaine(s)', value: 'week' },
                        { label: 'Mois', value: 'month' },
                        { label: 'Année(s)', value: 'year' }
                      ]}
                      onChange={(e) => setInactivityPeriodUnit(e.value)}
                      placeholder="Sélectionner une unité"
                      className='w-full'
                      optionLabel='label'
                    />
                  </div>
                  
                  {inactivityPeriodValue && (
                    <div className='col-12'>
                      <div className='p-3 border-round bg-purple-50 border-1 border-purple-200'>
                        <i className='pi pi-info-circle text-purple-600 mr-2'></i>
                        <span className='text-purple-800 font-semibold'>
                          Une alerte sera déclenchée si le capteur est inactif pendant plus de {inactivityPeriodValue} {
                            inactivityPeriodUnit === 'h' ? 'heure(s)' :
                            inactivityPeriodUnit === 'd' ? 'jour(s)' :
                            inactivityPeriodUnit === 'w' ? 'semaine(s)' :
                            inactivityPeriodUnit === 'm' ? 'mois' :
                            'année(s)'
                          }
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              
              {!inactivityAlertEnabled && (
                <div className='text-center py-3'>
                  <i className='pi pi-info-circle text-blue-500 text-2xl mb-2 block'></i>
                  <p className='text-600 m-0 text-sm'>
                    Activez cette option pour être alerté lorsque le capteur ne transmet plus de données pendant une période définie.
                  </p>
                </div>
              )}
            </div>
          </Card>
        </div>
      </DialogComponent>
      
      {/* Toast pour les notifications */}
      <Toast ref={toast} />
    </div>
  )
}
